<template>
    <div>
        <pagamento
            :pagamento="pagamento"
            :pagamentosServicos="obterPagamentosServicos()"
            v-show="mostrarPagamento"
            @obterPagamentoAtualizado="obterPagamentoAtualizado()"
        >
            <template slot="etapasBotoes">
                <b-button-group class="float-right">
                    <b-button
                        variant="primary"
                        @click="carregarAssociarEtapas()"
                        v-if="mostrarBtnAssociar"
                        ><i class="fa fa-plus"></i> Associar Etapas</b-button
                    >
                </b-button-group>
            </template>
            <template slot="despesasBotoes">
                <b-button-group class="float-right">
                    <b-button
                        variant="primary"
                        @click="carregarAssociarDespesas()"
                        v-if="mostrarBtnAssociar"
                        ><i class="fa fa-plus"></i> Associar Despesas</b-button
                    >
                </b-button-group>
            </template>
            <!-- <template slot="entregaAcoes" slot-scope="data">
                <span class="text-primary">
                    <i
                        class="fa fa-info-circle fa-lg icon-button"
                        title="Detalhar"
                        @click.stop="detalharEntrega(data.entregaId)"
                    ></i>
                </span>
            </template> -->
            <!-- <template slot="despViagensBotoes">
                <b-button-group class="float-right">
                    <b-button
                        variant="success"
                        @click="carregarAssociarDespViagens()"
                        v-if="mostrarBtnAssociarDespViagens"
                        >Associar Despesas de Viagens</b-button
                    >
                </b-button-group>
            </template> -->
        </pagamento>
        <router-view
            v-if="pagamento"
            :pagamento="pagamento"
            @obterPagamentoAtualizado="obterPagamentoAtualizado()"
        ></router-view>
    </div>
</template>

<script>
import PagamentosServicos from './PagamentosServicos'
import Pagamento from '@/app/sgtec/componentes/pagamentos/Pagamento'
import { pagamentoStatus } from '@/app/sgtec/componentes/pagamentos/PagamentoStatus'

export default {
    data() {
        return {
            pagamento: {}
        }
    },

    methods: {
        obterPagamento() {
            this.$store.dispatch('addRequest')
            PagamentosServicos.obterPorId(this.$route.params.pagamentoId).then(
                response => {
                    if (response) {
                        if (response.success) {
                            this.pagamento = response.data
                        } else {
                            this.$toast.error(
                                'Não foi possível obter o pagamento.',
                                'ERROR',
                                this.$toastConfig.error
                            )
                        }
                    }
                    this.$store.dispatch('removeRequest')
                }
            )
        },

        obterPagamentosServicos() {
            return PagamentosServicos
        },

        // detalharEntrega(entregaId) {
        //     this.$router.push({
        //         name: 'Credenciados_Finalizacoes_Entrega',
        //         params: {
        //             entregaId: entregaId
        //         }
        //     })
        // },

        obterPagamentoAtualizado() {
            this.obterPagamento()
            this.$store.dispatch('setRecarregar', true)
        },

        carregarAssociarEtapas() {
            this.$router.push({
                name: 'Sgtec_Fornecedor_Pagamentos_AssociarEtapas'
            })
        },
        
        carregarAssociarDespesas() {
            this.$router.push({
                name: 'Sgtec_Fornecedor_Pagamentos_AssociarDespesas'
            })
        }

        // carregarAssociarDespViagens() {
        //     this.$router.push({
        //         name: 'Credenciados_Finalizacoes_AssociarDespViagens'
        //     })
        // }
    },

    computed: {
        mostrarBtnAssociar() {
            return (
                (this.pagamento.status === pagamentoStatus.CRIADO ||
                    this.pagamento.status === pagamentoStatus.REPROVADO) &&
                this.$temAcesso('SGTEC-FORN-PAG-03')
            )
        },

        // mostrarBtnAssociarDespViagens() {
        //     return (
        //         (this.finalizacao.status === 0 ||
        //             this.finalizacao.status === 5) &&
        //         this.$temAcesso('CRED-FORN-FIN-03')
        //     )
        // },

        mostrarPagamento() {
            return this.$route.name === 'Sgtec_Fornecedor_Pagamentos_Detalhar'
        }
    },

    components: {
        Pagamento: Pagamento
    },

    created() {
        this.obterPagamento()
    }
}
</script>
